import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

import { isFuncComp } from '../../../../components/common/Helpers';

const shippingInfo = Loadable(() =>
  !isFuncComp() ? import('../../containers/web/shippingInfo') : import('../../FuncComponnetContainers/web/shippingInfo'),
);
export default MapTo('vcg/components/soe-home/react/shippingInfo')(shippingInfo);
